module.exports = __webpack_public_path__ + "static/media/RedtailCrmLogo.ca971136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/components/ImportClientModal/components/RedtailLogin/assets/RedtailCrmLogo.svg
// module id = 7310
// module chunks = 0